import React, { useState, useEffect } from "react";
import Layout from "./Layout";
import { useParams } from "react-router-dom";
import { API_URL } from "../config";
import HTMLReactParser from "html-react-parser";
import Loader from "./Loader";
import useApiUrlTranslation from "./useApiUrlTranslation";
import RegistrationFormContactPreferencesSection from "./RegistrationFormContactPreferencesSection";
import { Avatar, Button } from "@material-ui/core";
import { AnimatedButton } from "./Ui/Button";
import { Mail, Phone, Users, Zap } from "lucide-react";
import DemoDetailsContact from "./DemoDetailsContact";

const DemoDetails = (props) => {

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation()

    let { id_presta, idEvent } = useParams();

    const [demo, setDemo] = useState(null);

    let publicContactIsVisible = props.publicContactIsVisible ?? true;

    const handleButtonClick = () => {
        window.location.href = `/events/${idEvent}/programm/${id_presta}/demo-details/`;
    };


    function extractYouTubeVideoId(url) {
        // Modèle de regex pour extraire l'ID de la vidéo YouTube
        var regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\r\n]+)/;

        // Utiliser la regex pour extraire l'ID de la vidéo
        var match = url.match(regex);

        if (match && match[1]) {
            return match[1];
        } else {
            // Gérer le cas où l'URL n'est pas valide
            return null;
        }
    }


    useEffect(() => {

        const fetchGetDemo = async () => {

            await fetch(`${apiUrlTranslation}?action=getDemo&id_demo=${id_presta}`)
                .then((res) => res.json())
                .then((res) => setDemo(res));
        }

        fetchGetDemo();
    }, [i18n.resolvedLanguage]);



    if (!demo) {
        return false
    }
    let visuel = null;
    let logo = null;

    if (!demo.contact.logo.includes("no_picture")) {
        logo = demo.contact.logos.large;
        console.log(demo.contact.logo);
    }

    if (!demo.visuels.medium.includes("no_picture")) {
        visuel = demo.visuels.source;
    }

    return <Layout className=" ">




        <div className="bg-neutral-950 text-center  flex flex-col   justify-between items-center py-20 space-x-3   ">

            <div className="mb-8 mt-40">
                <div className="inline-flex items-center px-4 py-2 bg-neutral-100 rounded-full border border-neutral-200 mb-6">
                    <Zap className="w-4 h-4 text-cyan-500 mr-2" />
                    <span className="text-neutral-600 text-sm">{demo.contact.societe}  présente</span>
                </div>
            </div>


            <div className="hidden flex pt-10 text-2xl text-neutral-300 font-bold mb-4 items-center space-x-3">

                {logo && <img
                    className=" max-h-32 h-32 object-cover   p-2"
                    alt="visuel de la démonstration"
                    src={logo}

                />}

                <span className="text-white"> {demo.contact.societe} présente</span> </div>
            <h1 className="text-2xl  lg:text-5xl   font-bold mb-4 text-white">
                {demo.presta_nom}
            </h1>
        </div>



        <div className="mx-auto bg-neutral-50 ">

            <div className="flex flex-col lg:flex-row  rounded-3xl overflow-hidden my-10 ">
                {visuel ? <div><img src={visuel} alt="visuel de la démonstration" className=" h-100 object-cover " /></div> : ""}
                <div className="bg-neutral-100 px-5 py-5 ">
                    <p className="  leading-relaxed mb-6">
                        {HTMLReactParser(demo.presta_texte)}
                        {HTMLReactParser(demo.presta_accroche)}
                    </p>
                </div>
            </div>

            <div className="grid  gap-4">
                {demo.video_url && (
                    <div>
                        <h2 className="p-2 my-2 hidden">Vidéo de présentation</h2>
                        <iframe
                            className=""
                            width="100%"
                            height="720"
                            src={`https://www.youtube.com/embed/${extractYouTubeVideoId(demo.video_url)}`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                )}


            </div>



            {/* <RegistrationFormContactPreferencesSection contact={demo.contact} /> */}

            <h2 className="p-2 my-2 hidden">Descriptif de la démo</h2>
            <p className="text-start p-2 my-2 hidden">{HTMLReactParser(demo.presta_accroche ?? "")}</p>

            <DemoDetailsContact demo={demo} publicContactIsVisible={false} />



            {props.children}


            <div className="mx-auto max-w-xl my-5 ">
                <a
                    href={`/events/${idEvent}/programm/${id_presta}/demo-details-private/`}
                    className="max-w-fit  text-xl bg-pink-700 text-white rounded-full py-3 px-4 mx-4"

                >Connectez vous à <b>{demo.contact?.societe}</b></a>

            </div>
        </div>
    </Layout>


}

export default DemoDetails;


